/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { getSignInUrl, getSignUpUrl } from '@zcode-ui/account'
import { loadGlobalNavLinkpack, selectIsBot } from '@zcode-ui/web-zumper-global-state'
import { globalNavLinkpack } from '@zcode/nr/es/shared/api'
import { ON_SERVER } from '@zcode/nr/es/shared/env'
import { replace } from '@zcode/nr/es/shared/packages/history-middleware/actions'
import type { SSRLoadDataExtras } from '@zcode/nr/es/shared/packages/load-data/preloadRoutes'
import type { RouteComponentProps } from 'react-router-dom'
import { loadRentReport } from '../../modules/modals/thunks/hashtagModal/loadRentReport'
import type { Store } from '../../modules/types'
import { loadLinkpack } from './loadLinkpack'

export const loadData = async (
  store: Store,
  routeProps: RouteComponentProps,
  context?: SSRLoadDataExtras
) => {
  const { getState, dispatch } = store
  if (ON_SERVER) {
    const searchParams = new URLSearchParams(routeProps.location.search)
    if (searchParams.has('login')) {
      searchParams.delete('login')
      dispatch(
        replace(
          getSignInUrl(routeProps.history, {
            next: `${routeProps.location.pathname}?${searchParams}${routeProps.location.hash}`,
          })
        )
      )
    } else if (searchParams.has('signUp')) {
      searchParams.delete('signUp')
      dispatch(
        replace(
          getSignUpUrl(routeProps.history, {
            next: `${routeProps.location.pathname}?${searchParams}${routeProps.location.hash}`,
          })
        )
      )
    }
  }
  const state = getState()
  const isBot = selectIsBot(state)
  if (ON_SERVER && isBot) {
    await Promise.all([
      dispatch(loadLinkpack('addresses')),
      dispatch(loadLinkpack('buildings')),
      dispatch(loadGlobalNavLinkpack({ api: globalNavLinkpack })),
      dispatch(loadRentReport()),
    ])
  }
}
